import React, { useState, useEffect } from "react";
import { TouchableOpacity } from "react-native";
import Text from "../Text";
import { Container, Input, Display, Key } from "./styles";

const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

type KeypadProps = {
	onChange: (key: string) => void;
	value?: string | null;
	isDisabled?: boolean;
};

const Keypad = ({ onChange, value, isDisabled }: KeypadProps) => {
	const [pin, setPin] = useState("");
	const [activeKey, setActiveKey] = useState<String>();
	const isControlled = typeof value === "undefined" ? false : true;
	const renderValue = isControlled ? (value ? value : "") : pin;

	useEffect(() => {
		if (!isControlled) {
			onChange?.(pin);
		}
	}, [isControlled, pin]);

	const onKeyPress = (key) => {
		if (!isDisabled) {
			if (isControlled) {
				if (value.length < 4) {
					onChange?.(renderValue + key);
				}
			} else {
				if (pin.length < 4) {
					setPin(pin + key);
				}
			}
		}
	};

	return (
		<Container>
			<Display>
				<Text type="keypad">{"#".repeat(renderValue.length)}</Text>
			</Display>
			<Input>
				{keys.map((key) => {
					const isActive = key === activeKey;
					return (
						<TouchableOpacity
							key={`Key_${key}`}
							onPress={() => onKeyPress(key)}
							onPressIn={() => setActiveKey(key)}
							onPressOut={() => setActiveKey(null)}>
							<Key
								isActive={isActive}
								style={{ marginBottom: 10 }}>
								<Text
									type="keypad"
									style={
										isActive && {
											color: "#ffffff",
										}
									}>
									{key}
								</Text>
							</Key>
						</TouchableOpacity>
					);
				})}
			</Input>
		</Container>
	);
};

export default Keypad;
